import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsButton, BsCard, BsForm, BsFormControl } from '../../collection/bootstrap/BootstrapComponents';

/**
 * Filter for l tables with Name field.
 * Props:
 * - onFilter(data): Función que se ejecuta cuando se debe actualizar la tabla, la función recibe los datos del formulario de filtro y debe devolver la tabla resultante.
 * - defaultValue: Valores por defecto del filtro.
 */
export default function NombreFilter(props) {
    const { defaultValue, onFilter, ...otherProps } = props;

    const updateData = () => defaultValue;
    const saveData = async data => await onFilter(data);

    return <BsForm
        onUpdate={updateData}
        onSave={saveData}>
        <NombreFilterForm {...props} />
    </BsForm>;
}

function NombreFilterForm(props) {
    const data = props.data;

    return <>
        <BsCard header="Filtro" className={props.className}>
            <>
                <Row className="gy-3 mb-3">
                    {/* Nombre */}
                    <Col md="6">
                        <BsFormControl
                            label="Nombre" name="nombre"
                            value={data.nombre} />
                    </Col>
                </Row>
            </>
            <div className="d-flex justify-content-center gap-3 mt-3">
                <BsButton onClick={props.onSubmit}>Mostrar resultados</BsButton>
            </div>
        </BsCard>
    </>
}
